import axios from "axios";
import { authHeaderJson } from "../auth-header.service";
import cloneDeep from 'lodash-es/cloneDeep';
import { requestExportToken } from "../export.service";


const geMessageById = (messageId, sectionPartyMemberId) => {
    return axios.get(`/api/sbMessage/messageHome/${ messageId }/${ sectionPartyMemberId }`, { headers: authHeaderJson() } )
};

/*const saveMessage = (objMessage) => {
    return axios.post(`/api/sbMessage/messageadd`, objMessage, { headers: authHeaderJson() } )
};*/

const saveMessage = (objMessage) => {
    /*const aux_objMessage = cloneDeep(objMessage);
    aux_objMessage.item_message.title = encodeURIComponent(aux_objMessage.item_message.title);
    aux_objMessage.item_message.senderUsername = encodeURIComponent(aux_objMessage.item_message.senderUsername);
    aux_objMessage.item_message.body = encodeURIComponent(aux_objMessage.item_message.body);
    aux_objMessage.item_message.messageNemo = encodeURIComponent(aux_objMessage.item_message.messageNemo);
    aux_objMessage.item_message.messageCode = encodeURIComponent(aux_objMessage.item_message.messageCode);

    aux_objMessage.signatureQR = encodeURIComponent(aux_objMessage.signatureQR);
    aux_objMessage.sendedPartyName = encodeURIComponent(aux_objMessage.sendedPartyName);
    aux_objMessage.sectionName = encodeURIComponent(aux_objMessage.sectionName);
    aux_objMessage.answerMessageCode = encodeURIComponent(aux_objMessage.answerMessageCode);*/

    //[##PENTEST##]
    //return axios.post(`/api/sbMessage/messageadd`, aux_objMessage, { headers: authHeaderJson() } )
    return axios.post(`/api/sbMessage/messageadd`, objMessage, { headers: authHeaderJson() } )
};

const sendAlertMessage = (bookId, sectionId, messageId) => {
    return axios.get(`/api/sbMessage/meesagealert/${ bookId }/${ sectionId }/${ messageId }`, { headers: authHeaderJson() } )
};

const updateMessage = (objMessage) => {
    return axios.put(`/api/sbMessage/messageupdate`, objMessage, { headers: authHeaderJson() } )
};

const deleteMessage = (bookId, messageId, sectionPartyMemberId) => {
    return axios.delete(`/api/sbMessage/messagedelete/${ bookId }/${ messageId }/${ sectionPartyMemberId }`, { headers: authHeaderJson() });
};

const getMessageTreeByObjectByParty = (bookId, partyId, partyMemberId) => {
    return axios.get(`/api/sbMessage/messagesBook/${ bookId }/${ partyId }/${ partyMemberId }/list`, { headers: authHeaderJson() } )
};

const getMessageTreeByObjectByPartyLength = (userName, length) => {
    return axios.post(`/api/sbHome/messagesBook/list/${ length }`, userName, { headers: authHeaderJson() } )
};

const getMessageTreeByObjectByPartyExcelData = async (bookId, partyId, partyMemberId) => {
    const token = await requestExportToken("messagesBookExcelData");
    return axios.get(
        `/api/sbMessage/messagesBookExcelData/${bookId}/${partyId}/${partyMemberId}/list?exportToken=${token}`,
        { headers: authHeaderJson() }
    );
};

const getAddSignature = (objSignature) => {
    return axios.post(`/api/sbMessage/messageSignatureadd/`, objSignature, { headers: authHeaderJson() } )
};

const saveMessageVisa = (objMessageVisa) => {
    return axios.post(`/api/sbMessage/messageadd/visa`, objMessageVisa, { headers: authHeaderJson() } )
};

export {
    geMessageById,
    saveMessage,
    sendAlertMessage,
    updateMessage,
    deleteMessage,
    getMessageTreeByObjectByParty,
    getMessageTreeByObjectByPartyLength,
    getMessageTreeByObjectByPartyExcelData,
    getAddSignature,
    saveMessageVisa
}